"use client";

import CustomButton from "@/components/CustomButton";
import { ButtonVariant } from "@/components/CustomButton";

const FourOhFour = () => {
    return (
        <div className="flex flex-col items-center justify-center h-[80vh]">
            <div className="dark:hidden flex flex-col items-center justify-center">
                <img src={"/404_light.svg"} alt="404" className="h-72 " />
                <CustomButton
                    label="Go Back Home"
                    action={() => window.location.href = "/"}
                    variant={ButtonVariant.OUTLINE}
                />
            </div>
            <div className="dark:flex hidden flex-col items-center justify-center">
                <img src={"/404_dark.svg"} alt="404" className="h-72 " />
                <CustomButton
                    label="Go Back Home"
                    action={() => window.location.href = "/"}
                    variant={ButtonVariant.OUTLINE}
                    isDarkMode
                />
            </div>
        </div>
    );
}

export default FourOhFour;